export default {
    faq: {
        faq_detail: '상세',
    },
}


// WEBPACK FOOTER //
// ./src/lang/ko-KR.js